
const nextSubtitle = {
  "startTime": 0,
  "endTime": 0,
  "text": "添加字幕内容",
  "outward": null,
  "dropShadow": {
    "x": 0,
    "y": 0,
    "blur": 0,
    "spread": 0,
    "color": "#273F9F"
  },
  "font": {
    "color": "#303233",
    "fontSize": 54,
    "fontFamilyUrl": "2018-5-16/1526467728442.TTF",
    'fontFamilyLabel': '方正黑体',
    "fontStretch": "normal",
    "fontWeight": "normal",
    "fontStyle": "normal",
    "textDecoration": "none",
    "textAlign": "center",
    "wordBreak": "break-word",
    "writingMode": "inherit",
    //"isTextStroke": true,
    "myTextStroke": 1,
    "myTextStrokeColor" : "#ffffff"
  }
}

const state = {
  active: false,
  isShowExport: false,
  subtitleObj: {},
  subtitles: [],
  subIndex: -1,
  openSubtitle: false,
  startType: '',
  selectSubtitle: null,
  selectTextUI: null,
  subtitleEditor: null,
  undoRedoManager: {
    canUndo: true,
    canRedo: false,
  },
  subtitleDisplay: {

  },
  defaultSubtitle: {
    "outward": {
      "x": 0,
      "y": 87,
    },
    "dropShadow": {
      "x": 0,
      "y": 0,
      "blur": 0,
      "spread": 0,
      "color": "#273F9F"
    },
    "font": {
      "color": "#303233",
      "fontSize": 54,
      "fontFamilyUrl": "2018-5-16/1526467728442.TTF",
      'fontFamilyLabel': '方正黑体',
      "fontStretch": "normal",
      "fontWeight": "normal",
      "fontStyle": "normal",
      "textDecoration": "none",
      "textAlign": "center",
      "wordBreak": "break-word",
      "writingMode": "inherit",
      "myTextStroke": 1,
      "myTextStrokeColor": "#ffffff"
    }
  },
  isPreventDefault: true
}


const getters = {
  isShowExport: state => state.isShowExport,
  subtitleObj: state => state.subtitleObj,
  subtitles: state => state.subtitles, // 字幕数组
  subIndex: state => state.subIndex, // 选中字幕的数组index
  selectSubtitle: state => state.selectSubtitle, // 当前选中的字幕
  selectTextUI: state => state.selectTextUI,
  openSubtitle: state => state.openSubtitle,
  startType: state => state.startType,
  defaultSubtitle: state => state.defaultSubtitle,
  subtitleEditor: state => state.subtitleEditor,
  isPreventDefault: state => state.isPreventDefault,
}

const mutations = {
  showExport (state, flag) {
    state.isShowExport = flag;
  },
  toggle_isPreventDefault(state, data) {
    // 设置是否阻止默认事件
    state.isPreventDefault = data;
  },
  setSubtitleObj(state, data) {
    console.log('setSubtitleObj', data);
    if(!data.contents) data.contents = [];
    if (!state.subtitleObj) {
      //data.title = state.subtitleObj.title;
      state.subtitleObj = data;
    }
    state.subtitleObj = data;//$.extend(true, state.subtitleObj, data)
    state.subtitles = state.subtitleObj.contents;
  },
  setTitle (state, data) {
    if (state.subtitleObj) {
      state.subtitleObj.title = data;
    }
  },
  addSubtitles (state, data) {
    // data: {subtitle: {}, index: 1} index 可不传（在末尾添加）
    if (!data || !data.subtitle) return;
    if (!data.index && data.index !== 0) {
      data.index = state.subtitles.length;
    }
    state.subtitleEditor.insertText(data.index, $.extend(true, {}, nextSubtitle, data.subtitle));
    // state.subtitles = state.subtitleObj.contents;
    // state.selectSubtitle = json;
    // state.subIndex = state.subtitles.indexOf(json);
    // state.subtitleEditor.selectIndex(state.subIndex);
  },
  setSubIndex (state, index) {
    // 根据index 选中字幕
    state.subIndex = index !== undefined ? index : -1;
    if (state.subtitles[state.subIndex]) {
      state.selectSubtitle = state.subtitles[state.subIndex]
    } else {
      state.selectSubtitle = null
    }
    if (state.subtitleEditor) {
      state.selectTextUI = state.subtitleEditor.textUIs[state.subIndex];
      state.subtitleEditor.selectIndex(state.subIndex);
    }

  },
  setSubtitleEditor (state, data) {
    state.subtitleEditor = data;
  },
  setOpenSubtitle (state, data) {
    state.openSubtitle = data;
  },
  setStartType (state, data) {
    state.startType = data;
  },
  delSubtitles (state, data) {
    // 根据data(index 可不传 删除当前选中的字幕) 删除字幕
    let index = data !== undefined ? data : state.subIndex;
    if (index < 0) return;
    state.subIndex = -1
    state.subtitleEditor.removeText(index);
    state.selectSubtitle = null
  },
  updateSubtitle (state, data) {
    // data: {subtitle: {}, index: 1} index 可不传（为当前选中的）
    if (data.index >= 0) {
      if (state.subtitles[data.index]) {
        $.extend(true, state.subtitles[data.index], data.subtitle)
        state.subtitleEditor.textUIs && state.subtitleEditor.textUIs[data.index].updateUI();
      }
    } else {
      if (state.selectSubtitle) {
        $.extend(true, state.selectSubtitle, data.subtitle);
        state.selectTextUI.updateUI();
      }
    }
    eve('updateSubtitleEve');
  },
  updateSubtitleUndo (state, data) {
    eve('updateSubtitleUndo', null, {
      index: data.index,
      data: JSON.parse(JSON.stringify(data.subtitle)),
      reData: JSON.parse(JSON.stringify(data.subtitleMemo || state.selectSubtitle)),
      reIndex: state.subIndex,
    });

    // 记录上一个设置的属性
    let sub = data.subtitleMemo || state.selectSubtitle;
    sub = $.extend(true, {}, sub, data.subtitle);
    Object.assign(nextSubtitle.font, sub.font)
    Object.assign(nextSubtitle.dropShadow, sub.dropShadow)

    return mutations.updateSubtitle(state, data);
  },
  clearSubtitles (state) {
    state.subtitleEditor.selectIndex(-1);
    state.subtitleEditor.clear();
    state.subtitles = state.subtitleObj.contents || [];
    state.subIndex = -1;
  },
  addGroupSubtitles (state, data) {
    let subObj = null;

    for (let i in data.subtitles) {
      subObj = {}
      subObj.subtitle = $.extend(true, {}, data.subtitles[i])
      if(data.index > -1) {
        subObj.index = + i + data.index
      }
      mutations.addSubtitles(state, subObj)
    }
  },
  changeScenesTime(state, data) {
    const SE = state.subtitles;
    const [tn, ct] = data;
    let st = null;
    for (let i = 0; i < SE.length; i++) {
      st = SE[i]
      if (st.endTime <= tn + ct) continue;
      if (st.startTime.toFixed(3) >= tn) {
        st.startTime += ct;
        st.endTime += ct;
        continue;
      }
      if (ct < 0) {
        if (st.startTime > tn + ct - 0.2 && st.startTime < tn) {
          state.subtitleEditor.removeText(i);
          i--;
          continue;
        }
        if (st.startTime <= tn + ct - 0.2 && st.endTime > tn + ct) {
          st.endTime = tn + ct;
          continue;
        }
      }
    }
  },
  delScenesSound(state, ct) {
    const SE = state.subtitles;
    const dur = ct[1] - ct[0];
    let st = null;
    for (let i = 0; i < SE.length; i++) {
      st = SE[i];
      if (st.endTime <= ct[0]) continue;
      if (st.startTime >= ct[1]) {
        st.endTime -= dur;
        st.startTime -= dur;
        continue;
      }
      if (st.startTime <= ct[0] - 0.2) {
        st.endTime = ct[0];
      } else {
        state.subtitleEditor.removeText(i);
        i--;
      }
    }
  },
  addScenesSound(state, data) {
    const {changeTime: ct, subtitles} = data;
    const SE = state.subtitles;
    const dur = ct[1] - ct[0];
    let st = null;
    let insertIndex = 0;
    for (let i = 0; i < SE.length; i++) {
      st = SE[i];
      if (st.endTime <= ct[0]) {
        insertIndex++;
        continue;
      }
      if (st.startTime >= ct[0]) {
        st.endTime += dur;
        st.startTime += dur;
        continue;
      }
      if ( st.startTime <= ct[0] - 0.2) {
        st.endTime = ct[0];
        insertIndex++;
      } else {
        if (st.endTime < ct[0] + 0.2) {
          state.subtitleEditor.removeText(i);
          i--;
        } else {
          st.startTime = ct[1];
          st.endTime += dur;
        }
      }
    }
    if (subtitles.length) {
      mutations.addGroupSubtitles(state, {
        index: insertIndex,
        subtitles
      })
    }
  },
  swapScenesSound(state, ct) {
    // 将时间段ct[0]-ct[1] 移动到ct[2]位置
    const SE = state.subtitles;
    const dur = ct[1] - ct[0];
    let st = null;
    if (ct[0] < ct[2]) {
      for (let i = 0; i < SE.length; i++) {
        st = SE[i];
        if (st.endTime < ct[0]) continue;
        if (st.startTime >= ct[1] && st.endTime <= ct[2]) {
          st.endTime -= dur;
          st.startTime -= dur;
          continue;
        }
        if (st.startTime >= ct[2]) continue;
        if (st.startTime <= ct[0] - 0.2) {
          st.endTime = ct[0];
          continue;
        } else if (st.startTime <= ct[1] - 0.2) {
          if (st.startTime < ct[0]) {
            if (st.endTime < ct[0] + 0.2) {
              state.subtitleEditor.removeText(i);
              i--;
              continue;
            }
            st.startTime = ct[0];
          }
          if (st.endTime > ct[1]) {
            st.endTime = ct[1];
          }
          st.startTime = st.startTime + ct[2] - ct[1];
          st.endTime = st.endTime + ct[2] - ct[1];
        } else if (st.startTime <= ct[2] - 0.2) {
          if(st.startTime < ct[1]) {
            st.startTime = ct[1]
          }
          if (st.endTime > ct[2]) {
            st.endTime = ct[2]
          }
          st.startTime -= dur;
          st.endTime -= dur;
        } else if (st.startTime < ct[2]) {
          if (st.endTime < ct[2] + 0.2) {
            state.subtitleEditor.removeText(i);
            i--;
            continue;
          }
          st.startTime = ct[2];
        }
      }
    } else {
      for (let i = 0; i < SE.length; i++) {
        st = SE[i];
        if (st.endTime <= ct[2]) continue;
        if (st.startTime >= ct[2] && st.endTime <= ct[0]) {
          st.startTime += dur
          st.endTime += dur
          continue;
        }
        if (st.startTime >= ct[1]) continue;
        if (st.startTime <= ct[2] - 0.2) {
          st.endTime = ct[2];
          continue;
        } else if (st.startTime <= ct[0] - 0.2) {
          if (st.startTime < ct[2]) {
            if (st.endTime < ct[2] + 0.2) {
              state.subtitleEditor.removeText(i);
              i--;
              continue;
            }
            st.startTime = ct[2];
          }
          if (st.endTime > ct[0]) {
            st.endTime = ct[0];
          }
          st.startTime += dur;
          st.endTime += dur;
        } else if (st.startTime <= ct[1] - 0.2) {
          st.startTime = st.startTime - ct[0] + ct[2];
          st.endTime = st.endTime - ct[0] + ct[2];
          if (st.startTime < ct[2]) {
            st.startTime = ct[2]
          }
          if (st.endTime > ct[2] + dur) {
            st.endTime = ct[2] + dur
          }
        } else if (st.startTime < ct[1]) {
          if (st.endTime < ct[1] + 0.2) {
            state.subtitleEditor.removeText(i);
            i--;
            continue;
          }
          st.startTime = ct[1]
        }
      }
    }
    SE.sort((a, b) => {
      return a.startTime - b.startTime;
    })
  },
  updateScenesSound(state, data) {
    const { changeTime: ct, subtitles } = data;
    const SE = state.subtitles;
    const dt = ct[2] - ct[1];
    let st = null;
    for (let i = 0; i < SE.length; i++) {
      st = SE[i];
      if (st.endTime <= ct[0]) continue;
      if (st.startTime >= ct[1]) {
        st.startTime += dt;
        st.endTime += dt;
        continue;
      }
      if (st.startTime <= ct[0] - 0.2) {
        st.endTime = ct[0];
      } else if (st.startTime < ct[1]) {
        if (st.endTime >= ct[1] + 0.2) {
          st.startTime = ct[2];
          st.endTime += dt;
        } else {
          state.subtitleEditor.removeText(i);
          i--;
        }
      }
    }
    if(subtitles.length) {
      mutations.addGroupSubtitles(state, {
        subtitles
      })
      SE.sort((a, b) => {
        return a.startTime - b.startTime;
      })
    }
  },
  getSubtitleTS(state, data) {
    const { timeSlot: ts, subtitles } = data;
    const SE = state.subtitles;
    let st = null;
    for (let i = 0; i < SE.length; i++) {
      st = SE[i];
      if (st.startTime > ts[1] - 0.2) break;
      if (st.startTime > ts[0] - 0.2) {
        subtitles.push({
          text: st.text,
          startTime: Math.max(st.startTime - ts[0], 0),
          endTime: Math.min(st.endTime, ts[1]) - ts[0],
          font: Object.assign({}, st.font),
          dropShadow: Object.assign({}, st.dropShadow),
          outward: Object.assign({}, st.outward)
        })
      }
    }
  }
}

//测试
// if (!state.subtitleObj) {
//   state.subtitleObj = testdata;
//   state.subtitles = state.subtitleObj.contents;
// }

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/subtitle.js